import {Link} from '@/i18n/routing';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {FC} from 'react';

interface Props {
  imageUrl: string;
  title: string;
  paragraph?: string;
  cta?: string;
  url?: string;
  onPress?: (form: string) => void;
  imageMaxHeight?: number;
  buttonId?: string;
}

const BusinessCard: FC<Props> = ({
  imageUrl,
  title,
  paragraph,
  cta,
  url,
  buttonId,
  onPress,
  imageMaxHeight,
}) => {
  const t = useTranslations('business');
  return (
    <div className="min-w-1/4 lg:max-w-[33%] flex-1 border border-gray-300 rounded-lg py-6 px-4 bg-greyscale-gray-lighter flex flex-col justify-between">
      <div>
        <div className="relative w-full aspect-video">
          <Image
            fill
            src={imageUrl}
            alt={title}
            className="rounded-md object-cover"
            style={{
              ...(imageMaxHeight && { maxHeight: `${imageMaxHeight}px` }),
            }}
          />
        </div>
        <div className="text-center mt-5">
          <h4 className="font-bold mb-3 text-xl">{title}</h4>
        </div>
        <p className="mb-4 text-gray-500 text-sm">{paragraph}</p>
      </div>
      <div className="text-center">
        {onPress ? (
          <button
            id={buttonId}
            className="button btn-primary btn-md leading-10"
            onClick={() => {
              url && onPress(url);
            }}
          >
            {cta || t('business-button')}
          </button>
        ) : (
          // @ts-expect-error
          <Link href={`/${url}`}>
            <button
              id={buttonId}
              className="button btn-primary btn-md leading-10"
            >
              {cta || t('business-button')}
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default BusinessCard;
